export function filterData(props, _id) {
  // no es suficiente el id
  var data = props.data,
      toggleCheckbox = props.toggleCheckbox,
      countryID = props.countryID,
      plotID = props.plotID;
  data.map(function (a) {
    if (a._id === _id) {
      toggleCheckbox(countryID, plotID, a._id);

      if (a.idx1) {
        if (!a.values) {
          a.idx1.map(function (b) {
            toggleCheckbox(countryID, plotID, b._id);

            if (b.idx2) {
              b.idx2.map(function (c) {
                toggleCheckbox(countryID, plotID, c._id);

                if (c.idx3) {
                  c.idx3.map(function (d) {
                    toggleCheckbox(countryID, plotID, d._id);
                  });
                }
              });
            }
          });
        }
      }
    }

    if (a.idx1) {
      a.idx1.map(function (b) {
        if (b._id === _id) {
          toggleCheckbox(countryID, plotID, b._id);

          if (!b.values) {
            if (b.idx2) {
              b.idx2.map(function (c) {
                toggleCheckbox(countryID, plotID, c._id);

                if (c.idx3) {
                  c.idx3.map(function (d) {
                    toggleCheckbox(countryID, plotID, d._id);
                  });
                }
              });
            }
          }
        }

        if (b.idx2) {
          b.idx2.map(function (c) {
            if (c._id === _id) {
              toggleCheckbox(countryID, plotID, c._id);

              if (!c.values) {
                if (c.idx3) {
                  c.idx3.map(function (d) {
                    toggleCheckbox(countryID, plotID, d._id);
                  });
                }
              }
            }

            if (c.idx3) {
              c.idx3.map(function (d) {
                if (d._id === _id) toggleCheckbox(countryID, plotID, d._id);
              });
            }
          });
        }
      });
    }
  });
}